var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import makeStyles from "@mui/styles/makeStyles";
var arrowCommonCSS = {
    border: "solid transparent",
    bottom: "100%",
    content: "' '",
    height: 0,
    width: 0,
};
export default makeStyles(function (_a) {
    var pxToRem = _a.typography.pxToRem, spacing = _a.spacing, _b = _a.palette, background = _b.background, grey = _b.grey, drawer = _a.zIndex.drawer;
    return ({
        paper: {
            padding: spacing(1),
            marginTop: spacing(1.5),
        },
        popper: {
            zIndex: drawer,
        },
        arrow: {
            border: "".concat(pxToRem(1), " solid ").concat(grey[500]),
            borderBottom: pxToRem(0),
            marginTop: spacing(1.5),
            width: 20,
            position: "relative",
            "&::after": __assign(__assign({}, arrowCommonCSS), { borderColor: "transparent transparent ".concat(background.paper, " transparent"), borderWidth: pxToRem(11), marginLeft: pxToRem(-1), position: "absolute", marginBottom: pxToRem(-1) }),
            "&::before": __assign(__assign({}, arrowCommonCSS), { borderBottomColor: grey[500], borderWidth: pxToRem(11), marginRight: pxToRem(-11), position: "absolute" }),
        },
    });
});
//# sourceMappingURL=useStyles.js.map